<template>
  <div class="wrap">
    <div class="section">
      <div class="d-flex">
        <a-button type="primary" @click="onAddType">{{$t('create')+$t('page_andon')+$t('page_andon_call_type')}}</a-button>
        <a-popconfirm
          :title="$t('delete_tips')+'?'"
          :okText="$t('ok')"
          :disabled="!selectedTypeKeys.length"
          :cancelText="$t('cancel')"
          @confirm="batchRemoveTypes"
        >
        <a-button
          type="default"
          :disabled="!selectedTypeKeys.length"
          style="margin-left: 8px"
          >{{$t('delete')}}</a-button
        >
      </a-popconfirm>
        <ImportButton
          filename=""
          :downloadFn="downloadFn"
          :importFn="importFn"
          :refresh="onSearchType"
          style="margin-left: 8px"
        />
        <a-button style="margin-left: 8px" type="default" @click="exportFn"
          >{{$t('page_product_export')}}</a-button
        >
        <a-button
          style="margin-left: 8px"
          :disabled="!selectedTypeKeys.length"
          @click="printing"
        >
          {{ $t("page_print_code") }}
        </a-button>
        <a-input-search
          v-model="keyword"
          style="width: 240px; margin-left: auto"
          :placeholder="$t('common_please_input') + $t('keyword')"
          @search="onSearchType"
          :enterButton="$t('search')"
        />
      </div>
      <div class="table-wrap" ref="table1">
        <ml-table
          :columns="columns"
          :canChangeColWidth="true"
          :pagination="pagination"
          :loading="typeLoading"
          :data-source="typeDataList"
          rowKey="id"
          :rowSelection="{
            selectedRowKeys: selectedTypeKeys,
            onChange: onSelectTypeRows,
          }"
          :customRow="customTypeRow"
          :scroll="{y:table1Height}"
          @change="changePage"
        >
          <template #action="record">
            <a href="javascript:void(0);" @click="editType(record.id)">{{
              $t("edit") || "编辑"
            }}</a>
            <a-popconfirm
              :title="$t('delete_tips')+'?'"
              :okText="$t('ok')"
              :cancelText="$t('cancel')"
              @confirm="onRemoveType(record.id)"
            >
              <a
              href="javascript:;"
              @click.stop="() => {}"
              style="color: var(--color-red); margin-left: 10px"
              >{{ $t("delete") || "删除" }}
              </a>
            </a-popconfirm>
          </template>
          <template #color="text">
            <span :style="{'background-color': text}" class="bg-color"></span>
          </template>
        </ml-table>
      </div>
    </div>
    <div class="section" style="margin-top: 10px">
      <div class="reason-action" >
        <a-button type="primary" @click="onAddReason"
          >{{$t('create')}}{{$t('page_andon')}}{{$t('page_andon_call_reason')}}
          </a-button
        >
        <a-popconfirm
              :title="$t('delete_tips')+'?'"
              :okText="$t('ok')"
              :cancelText="$t('cancel')"
              :disabled="!selectedReasonKeys.length"
              @confirm="onRemoveReason(selectedReasonKeys)"
            >
        <a-button
          type="default"
          :disabled="!selectedReasonKeys.length"
          style="margin-left: 8px"
          >{{$t('delete')}}</a-button
        >
      </a-popconfirm>
      </div>

      <div class="table-wrap" ref="table2">
        <ml-table
          rowKey="id"
          :columns="reasonColumns"
          :loading="reasonLoading"
          :data-source="reasonDataList"
          :scroll="{y:table2Height}"
          :rowSelection="{
            selectedRowKeys: selectedReasonKeys,
            onChange: onSelectReasonRows,
          }"
          :pagination="reasonPagination"
          @change="changeReasonPage"
        >
          <template #action="record">
            <a href="javascript:void(0);" @click="editReason(record.id)">{{
              $t("edit") || "编辑"
            }}</a>
             <a-popconfirm
              :title="$t('delete_tips')+'?'"
              :okText="$t('ok')"
              :cancelText="$t('cancel')"
              @confirm="onRemoveReason([record.id])"
            >
              <a
                href="javascript:void(0);"
                style="color: var(--color-red); margin-left: 10px"
                >{{ $t("delete") || "删除" }}</a
              >
            </a-popconfirm>
          </template>
        </ml-table>
      </div>
    </div>
    <addTypeModal
      v-model="addTypeModalShow"
      @close="addTypeModalShow = false"
      @submit="onSearchType"
      :id="editId"
    />
    <addReasonModal
      v-model="addReasonModalShow"
      :typeData="currentTypeRow"
      @close="addReasonModalShow = false"
      :id="editReasonId"
      @submit="onSearchReason"
    />
    <code-model
      :visible="printVisible"
      @cancel="codeCancel"
      :dataList="codeDataList"
      @print="handlerPrint"
    >
    </code-model>
  </div>
</template>
<script>
import ImportButton from "@/components/ImportButton/index.vue";
import ExportButton from "@/components/ExportButton/index.vue";
import addTypeModal from "./components/addTypeModal.vue";
import addReasonModal from "./components/addReasonModal.vue";
import { downloadFile } from "@/utils";
import {
  exportAndonTypeTpl,
  importAndonType,
  exportAndonType,
} from "@/api/api";
import {
  AndonTypeServiceProxy,
  AndonReasonServiceProxy,
} from "@/service-proxies/app-v2/andon.service-proxies";
const andonTypeServiceProxy = new AndonTypeServiceProxy();
const andonReasonServiceProxy = new AndonReasonServiceProxy();
export default {
  components: {
    ImportButton,
    ExportButton,
    addTypeModal,
    addReasonModal,
  },
  created() {
    this.getTypeList();
  },
  mounted(){
    this.$nextTick(() => {
      this.table1Height = this.$refs.table1.clientHeight - 82;
      this.table2Height = this.$refs.table2.clientHeight -82;
    })
  },
  methods: {
    // 新建呼叫类型
    onAddType() {
      this.editId = "";
      this.$nextTick(() => {
        this.addTypeModalShow = true;
      });
    },
    onRemoveType(id) {
      const _this = this;
      _this.handleRemoveType([id]);
    },
    batchRemoveTypes() {
      const _this = this;
      _this.handleRemoveType(_this.selectedTypeKeys);
    },
    handleRemoveType(ids) {
      const _this = this;
      andonTypeServiceProxy.deleteAndonType(ids).then((res) => {
        _this.$message.success(_this.$t('delete_success'));
        _this.resetSelectRow();
        _this.onSearchType();
      });
    },
    onSearchType() {
      this.addTypeModalShow = false;
      if (!this.editId) {
        this.pagination.current = 1;
        this.resetSelectRow();
      }
      this.editId = "";
      this.getTypeList();
    },
    // 重置选中的类型
    resetSelectRow() {
      this.selectedTypeKeys = [];
      this.currentTypeRow = null;
    },
    // 获取类型
    async getTypeList() {
      let { current, pageSize } = this.pagination;
      this.typeLoading = true;
      await andonTypeServiceProxy
        .getPageAndonReason(current, this.keyword, pageSize)
        .then((res) => {
          this.typeLoading = false;
          this.typeDataList = res.records;
          this.pagination.total = res.total;
          if (this.typeDataList.length && !this.selectedTypeKeys.length) {
            this.currentTypeRow = this.typeDataList[0];
            this.selectedTypeKeys = [this.typeDataList[0].id];
            this.onSearchReason();
          } else {
            this.resetSelectRow();
          }
        });
    },
    // 导出
    onExport() {},
    // 编辑
    editType(id) {
      this.editId = id;
      this.$nextTick(() => {
        this.addTypeModalShow = true;
      });
    },
    // 下载模板
    downloadFn() {
      let fileName = this.$t('page_andon')+this.$t('page_andon_call_type')+this.$t('template')+'.xlsx'
      exportAndonTypeTpl().then((res) => {
        downloadFile(res, fileName);
      });
    },
    // 刷新
    refresh() {},
    // 导入
    importFn(data) {
      importAndonType(data);
    },
    // 导出
    exportFn() {
      let fileName = this.$t('page_andon')+this.$t('page_andon_call_type')+'.xlsx'
      exportAndonType().then((res) => {
        downloadFile(res, fileName);
      });
    },
    // 类型分页
    changePage(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.resetSelectRow();
      this.getTypeList();
    },
    onSelectTypeRows(keys, rows) {
      this.selectedTypeKeys = keys;
      if (rows.length) {
        this.currentTypeRow = rows[0];
      } else {
        this.currentTypeRow = null;
      }
      this.onSearchReason();
    },
    customTypeRow(record) {
      return {
        on: {
          // 事件
          click: (event) => {
            this.currentTypeRow = record;
            this.selectedTypeKeys = [record.id];
            this.onSearchReason();
          }, // 点击行
        },
      };
    },

    // 原因
    onSearchReason() {
      if (!this.editReasonId) {
        this.reasonPagination.current = 1;
      }
      this.editReasonId = "";
      this.addReasonModalShow = false;
      this.getReasonList();
    },
    // 获取原因列表
    getReasonList() {
      this.reasonDataList = [];
      if (!this.currentTypeRow) return;
      let { current, pageSize } = this.reasonPagination;
      this.reasonLoading = true;
      andonReasonServiceProxy
        .getPageAndonReason(current, pageSize, this.currentTypeRow.id)
        .then((res) => {
          this.reasonLoading = false;
          this.reasonDataList = res.records || [];
          this.reasonPagination.total = res.total;
        });
    },
    // 分页
    changeReasonPage(pagination) {
      this.reasonPagination.current = pagination.current;
      this.reasonPagination.pageSize = pagination.pageSize;
      this.getReasonList();
    },
    onSelectReasonRows(keys, rows) {
      this.selectedReasonKeys = keys;
    },
    // 新增原因
    onAddReason() {
      this.addReasonModalShow = true;
    },
    // 编辑原因
    editReason(id) {
      this.editReasonId = id;
      this.$nextTick(() => {
        this.addReasonModalShow = true;
      });
    },
    // 删除原因
    onRemoveReason(id) {
      const _this = this;
      _this.handleRemoveReason(id);
    },
    handleRemoveReason(ids) {
      const _this = this;
      andonReasonServiceProxy.deleteAndonReason(ids).then((res) => {
        _this.$message.success(_this.$t("delete_success"));
        _this.selectedReasonKeys = [];
        _this.onSearchReason();
      });
    },
    // 打印编码相关

    //取消
    printing() {
      // this.getList()
      let arr = [];
      this.typeDataList.forEach((item) => {
        if (this.selectedTypeKeys.includes(item.id)) {
          arr.push({
            code: item.code,
            name: item.name,
          });
        }
      });
      this.codeDataList = arr;
      this.$nextTick(() => {
        this.printVisible = true;
      });
    },
    codeCancel() {
      this.printVisible = false;
    },
    // 打印
    handlerPrint() {
      this.selectedTypeKeys = [];
      this.printVisible = false;
    },
  },
  data() {
    return {
      keyword: "",
      pagination: {
        size: "normal",
        total: 0,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
      },
      table1Height:200,
      table2Height:200,
      typeLoading: false,
      columns: [
        {
          key: "action",
          title:this.$t('actions'),  //"操作",
          scopedSlots: { customRender: "action" },
        },
        {
          dataIndex: "index",
          key: "index",
          title:this.$t('serial_number'),  // "序号",
          customRender: (_, record, index) => {
            return index + 1;
          },
        },
        {
          dataIndex: "code",
          title:this.$t('page_andon') + this.$t('page_andon_call_type_code'),  // "安灯呼叫类型编码",
        },
        {
          dataIndex: "name",
          title:this.$t('page_andon') + this.$t('page_andon_call_type'), // "安灯呼叫类型",
        },
        {
          dataIndex: "employeeNames",
          title:this.$t('page_andon_call_processing_personnel'), // "处理人员",
        },
        {
          dataIndex: "color",
          title:this.$t('page_andon_call_type_status_color'), // "类型状态颜色",
          scopedSlots: { customRender: 'color' },
        },
        {
          dataIndex: "remark",
          title:this.$t('remark'), // "备注",
        },
      ],
      typeDataList: [
        /* {
        id:1,
        name:'sdfds'
      } */
      ],
      // 选择的类型
      selectedTypeKeys: [],
      addTypeModalShow: false,
      editId: "",
      currentTypeRow: null,
      // 原因
      reasonLoading: false,
      reasonColumns: [
        {
          key: "action",
          title:this.$t('actions'),  //"操作",
          scopedSlots: { customRender: "action" },
        },
        {
          dataIndex: "index",
          key: "index",
          title:this.$t('serial_number'),  // "序号",
          customRender: (_, record, index) => {
            return index + 1;
          },
        },
        {
          dataIndex: "code",
          title:this.$t('page_andon')+this.$t('page_andon_call_reason_code'),  // //"安灯呼叫原因编码",
        },
        {
          dataIndex: "name",
          title:this.$t('page_andon_andon_call_reason'),  // "安灯呼叫原因",
        },
        {
          dataIndex: "remark",
          title: this.$t('remark'),
        },
      ],
      reasonPagination: {
        size: "normal",
        total: 100,
        pageSize: 10,
        current: 1,
        showSizeChanger: true,
      },
      reasonDataList: [],
      selectedReasonKeys: [],
      addReasonModalShow: false,
      editReasonId: "",
      // 打印编码
      printVisible: false,
      codeDataList: [],
    };
  },
};
</script>
<style lang="less" scoped>
.wrap {
  padding: 8px 8px 8px 0;
  display: flex;
  height: 100%;
  flex-direction: column;
}
.section{
  flex:1;
  display: flex;
  overflow:auto;
  flex-direction: column;
}
.table-wrap {
  flex: 1;
  margin-top: 10px;
  overflow: auto;
}
/deep/ .ant-table-wrapper .ant-pagination{
  margin:8px 0
}
.bg-color{
  display: flex;
  width: 100%;
  height: 20px;
}
</style>
